import { Component } from '@angular/core';
// import { SocketService } from './socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(){}
  title = 'micro-demand';

  ngOnInit(){ }
}
